
import {DateTime} from "luxon";
import App from "@/App.vue";

export default {
  setUp: (vueInstance) => {
    vueInstance.filter('clock', (val) => {
      return DateTime.fromJSDate(val).setLocale(App.i18n.locale).toLocaleString({
        hour: "2-digit",
        minute: "2-digit",
      });
      /*
      return new Date(val).toLocaleTimeString("de", {
        hour: "2-digit",
        minute: "2-digit",
      });
      */
    })

    vueInstance.filter('dateLong', (val) => {
      return DateTime.fromJSDate(val).setLocale(App.i18n.locale).toLocaleString({
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    })

    vueInstance.filter('dateShort', (val) => {
      return DateTime.fromJSDate(val).setLocale(App.i18n.locale).toLocaleString({
        "day": "numeric",
        "month": "long",
        "year": "numeric"
      });
    })

    vueInstance.filter('dateVeryShort', (val) => {
      return DateTime.fromJSDate(val).setLocale(App.i18n.locale).toLocaleString({
        "day": "2-digit",
        "month": "2-digit",
        "year": "numeric"
      });
    })

    vueInstance.filter('dateLongMonth', (val) => {
      return DateTime.fromJSDate(val).setLocale(App.i18n.locale).toLocaleString({
        day: "numeric",
        month: "long",
      });
    })

    vueInstance.filter('weekday', (val) => {
      return DateTime.fromJSDate(val).setLocale(App.i18n.locale).toLocaleString({ weekday: "long" });
    })


    vueInstance.filter('preis', (val) => {
      if (!val) return "";
      if (isNaN(val)) return val;

      if (process.env.VUE_APP_CLINIUS_CH && process.env.VUE_APP_CLINIUS_CH === '1') {
        return `${parseFloat(val).toFixed(2).replace(".", ",")} CHF`;
      } else {
        return `${parseFloat(val).toFixed(2).replace(".", ",")} €`;
      }

    })
  }
}
